import axiosInstance from '../../../api/axiosInstance';
import { Session } from '../../../domain/entities';

export interface CreateSessionRequest {
  userId: number;
  siteId: number;
  typeOfWorkId: number;
  startTime: string;
}

export interface UpdateSessionRequest {
  endTime?: string;
  duration?: number;
  rate?: number;
  notes?: string;
}

class SessionApi {
  // Получение сессий
  async getAllSessionsForUser(userId: number): Promise<Session[]> {
    try {
      const response = await axiosInstance.get<Session[]>(`/Sessions/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all sessions:', error);
      throw error;
    }
  }

  async getOpenSessionsForUser(userId: number): Promise<Session[]> {
    try {
      const response = await axiosInstance.get<Session[]>(`/Sessions/user/${userId}/open`);
      return response.data;
    } catch (error) {
      console.error('Error fetching open sessions:', error);
      throw error;
    }
  }

  async getClosedSessionsForUser(userId: number): Promise<Session[]> {
    try {
      const response = await axiosInstance.get<Session[]>(`/Sessions/user/${userId}/closed`);
      return response.data;
    } catch (error) {
      console.error('Error fetching closed sessions:', error);
      throw error;
    }
  }

  async getSessionById(sessionId: number): Promise<Session | null> {
    try {
      const response = await axiosInstance.get<Session>(`/Sessions/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching session by id:', error);
      throw error;
    }
  }

  // Управление сессиями
  async createSession(request: CreateSessionRequest): Promise<Session> {
    try {
      const response = await axiosInstance.post<Session>('/Sessions', request);
      return response.data;
    } catch (error) {
      console.error('Error creating session:', error);
      throw error;
    }
  }

  async updateSession(sessionId: number, updates: UpdateSessionRequest): Promise<Session> {
    try {
      const response = await axiosInstance.put<Session>(`/Sessions/${sessionId}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating session:', error);
      throw error;
    }
  }

  async closeSession(sessionId: number, endTime: string): Promise<Session> {
    try {
      const response = await axiosInstance.patch<Session>(`/Sessions/${sessionId}/close`, { endTime });
      return response.data;
    } catch (error) {
      console.error('Error closing session:', error);
      throw error;
    }
  }

  async deleteSession(sessionId: number): Promise<boolean> {
    try {
      await axiosInstance.delete(`/Sessions/${sessionId}`);
      return true;
    } catch (error) {
      console.error('Error deleting session:', error);
      throw error;
    }
  }

  // Статистика
  async getSessionStatistics(userId: number, period: string = 'month'): Promise<any> {
    try {
      const response = await axiosInstance.get(`/Sessions/user/${userId}/statistics?period=${period}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching session statistics:', error);
      throw error;
    }
  }
}

export const sessionApi = new SessionApi();
